import { Box, Paper, Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { FOOTER_HEIGHT } from "../../../generic/components/fixed-footer";

export const FollowUpBody: FC<{ children: ReactNode }> = ({ children }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        flexGrow: 1,
        overflow: "auto", // Allows scrolling in the main content area
        height: `calc(100% - ${FOOTER_HEIGHT})`, // Subtract the height of the footer
        display: "flex",
        flexDirection: "column",
        background: theme.palette.background.paper,
      }}
    >
      <Box
        sx={{
          flexGrow: 1, // This will make the Box take up all remaining space
          mx: 8,
          my: 4,
        }}
      >
        <Stack spacing={4} direction="column">
          {children}
        </Stack>
      </Box>
    </Paper>
  );
};
